// Libraries
import React from 'react'

// Styles
import StyledProgress from './style'

interface PropsInterface {
  stage: number;
}

const Progress = ({ stage }: PropsInterface) => {
  return <StyledProgress src={`/progress_stage_${stage - 1}.svg`}
                         initial={{ opacity: .5 }}
                         animate={{ opacity: 1 }}
                         exit={{ opacity: 0 }}
                         transition={{ duration: .5 }}/>
}

export default  Progress
